import React from 'react';
import { IconX } from '@tabler/icons-react';
import { ButtonWithIcon } from 'ui-kit/Buttons';

type SidecarProps = {
  isOpen: boolean;
  onClose: () => void;
  widthPercent?: number;
  showOverlay?: boolean;
  header?: string;
  children: React.ReactNode;
};

export const Sidecar = ({
  isOpen,
  onClose,
  widthPercent = 35,
  showOverlay = true,
  header,
  children,
}: SidecarProps) => {
  const clampedWidth = Math.min(Math.max(widthPercent, 10), 90);

  return (
    <>
      {showOverlay && (
        <div
          className={`fixed inset-0 z-40 bg-black/40 transition-opacity ${
            isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
          }`}
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <aside
        role="dialog"
        aria-modal="true"
        className={`fixed right-0 top-0 z-50 h-full transform bg-background-canvas shadow-lg transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ width: `${clampedWidth}%` }}
      >
        <div className="flex h-full flex-col">
          <div className="flex items-center justify-between border-b border-gray-700 p-3">
            <div className="text-[18px] font-medium text-gray-200">{header || ''}</div>
            <ButtonWithIcon
              label="Close"
              icon={<IconX size={14} />}
              onClick={onClose}
              size="small"
              type="link"
              iconPosition="right"
              className="border-none"
            />
          </div>
          <div className="flex-1 overflow-y-auto p-4">{children}</div>
        </div>
      </aside>
    </>
  );
};
